import React, { Component } from "react";
import * as pr from "../../../common/PrimeComponents";
import * as Log from "../../../common/Feedback/Log";
import { CCSelectorViewModel } from "./CCSelectorViewModel";
import * as format from "../../../common/FormatFunctions";
import * as Feedback from "../../../common/Feedback/Feedback";

export class CCSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: [],
      firstLoad: true
    };

    this.viewModel = new CCSelectorViewModel();
    this.logger = Log;
  }
  componentDidMount = () => {};

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setViewModel = () => {
    try {
      this.viewModel.updateState = this.updateState;
      this.viewModel.showError = this.showError;
      this.viewModel.showSuccess = this.showSuccess;
      this.viewModel.showEmpty = this.showEmpty;
    } catch (error) {}
  };

  showError = (display, crudlStatus) => {
    Feedback.showError(this.growl, display, crudlStatus);
  };
  showSuccess = (display, crudlStatus) => {
    Feedback.showSuccess(this.growl, display, crudlStatus);
  };
  showEmpty = display => {
    Feedback.showEmpty(this.growl, display);
  };

  updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  reset = list => {
    if (format.isNotNull(list)) {
      list.forEach(element => {
        this.updateState(element, null);
      });
    }
  };
  resetProps = list => {
    if (format.isNotNull(list)) {
      list.forEach(element => {
        this.props.updateState(element, null);
      });
    }
  };

  setPageData = async () => {
    if (this.props.type === "CLIENT") {
      if (this.props.businessId) {
        if (!this.state.catalogueOptions) {
          //  await this.viewModel.getCataloguesByClientId(this.props.businessId);
          if (this.state.firstLoad) {
            if (this.props.catalogueId) {
              this.getCategorysFromSelectedCatalogue(this.props.catalogueId);
            }
          }
        }
      }
    } else {
      if (!this.state.catalogueOptions) {
        await this.viewModel.getCatalogues();
        if (this.state.firstLoad) {
          if (this.props.catalogueId) {
            this.getCategorysFromSelectedCatalogue(this.props.catalogueId);
          }
        }
      }
    }
  };

  getCategorysFromSelectedCatalogue = async id => {
    this.props.updateState("catalogueId", id);
    await this.viewModel.getCategorys(id);
    if (this.state.firstLoad) {
      this.setState({ firstLoad: false });
    }
  };

  render() {
    this.initialDataRender();

    return (
      <React.Fragment>
        <div className="ui-g-12">
          <div className="ui-g-3">
            <label className="input-label">Catalogue</label>
          </div>

          <div className="ui-g-9">
            <pr.Dropdown
              value={this.props.catalogueId || ""}
              options={this.state.catalogueOptions}
              onChange={e => {
                this.resetProps(["categoryId"]);
                this.reset(["categoryOptions"]);
                this.getCategorysFromSelectedCatalogue(e.value);
              }}
              filter={true}
              filterBy="label"
              filterPlaceholder="Search"
              style={{ width: "100%" }}
            />
          </div>
        </div>
        {format.isNotNull(this.props.catalogueId) && (
          <div className="ui-g-12">
            <div className="ui-g-3">
              <label className="input-label">Category</label>
            </div>

            <div className="ui-g-9">
              <pr.Dropdown
                value={this.props.categoryId || ""}
                options={this.state.categoryOptions}
                onChange={e => {
                  this.props.updateState("categoryId", e.value);
                }}
                filter={true}
                filterBy="label"
                filterPlaceholder="Search"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Catalogues/legacy/CCSelector.js